import { render, staticRenderFns } from "./AddUpdateObjectiveForm.vue?vue&type=template&id=569806c3&"
import script from "./AddUpdateObjectiveForm.vue?vue&type=script&lang=js&"
export * from "./AddUpdateObjectiveForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports